export const ESTIMATES_PDF_BASE_NAME = 'Cost Estimate Results'
export const ESTIMATES_PDF_AUTHOR = 'Health EZ'
export const ESTIMATES_PDF_PAGE_SIZE = 'A4'
export const LOGO_URI = '/images/HEZ_LOGO_Green.png'
export const NUMBER_NOT_AVAILABLE = '--'
